// extracted by mini-css-extract-plugin
export default {"root":"MJm86e"};